export default "__VITE_ASSET__AVpE94zB__"